import Text from './Text.component';
import TextTextMode from './displayMode/TextMode.component';

export { TextTextMode };
export default Text;
